module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/babel-runtime/core-js/symbol.js
// module id = 373
// module chunks = 0